import { CircularProgress} from '@material-ui/core';
import Slider from '@material-ui/core/Slider';
import {makeStyles} from '@material-ui/core/styles';
import {format} from 'date-fns';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { useHistory, useParams } from 'react-router-dom';
import { httpRequest } from '../../../httpRequest';
import {
  getSessionStorageItem,
  setSessionStorageItem,
  ADVISOR_OBJECT_KEY,
  SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, SESSION_STORAGE_CASE_RETURN_PATH,
  SESSION_STORAGE_CREATE_CASE, SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY
} from '../../../sessionStorage';
import Breadcrumb from '../../Common/Breadcrumb/Breadcrumb';
import getQuoteTypeFromID from '../../Common/GetQuoteTypeFromID';
import {getPermission} from '../../Helpers/CheckAccess';
import {AdvisorCaseType} from "../../Helpers/Constants/CaseType";
import {isBlank} from '../../Helpers/Conversion';
import PersonCard from './CaseDetailsPersonCard';
import CaseDetailTool from './CaseDetailsTool';
import {configureStatusObject, getStatusProgress, statuses} from './status';
import './CaseDetails.scss';
import SvgIcon from '@material-ui/core/SvgIcon';
import WarningGroup from '../../../icons/Warning-group.svg';
import { ConvertUTCToLocalDate, ConvertUTCToLocalDateTime } from '../../Helpers/Formatters/UTCToLocalDate';
import * as Steps from "../../Product/CreateCase";
import * as TermSteps from "../../Product/TermLifeInsurance/steps";
import {GetFormattedNumber} from "../../Helpers/Formatters";
import { policyOwnerships } from '../../Product/SharedComponents/RetrieveAccount/Helpers/Constants';
import { insurancePolicyTypes, SourceOfFunds, getNormalizedOptionValue } from '../../Product/ABLTC/SubComponents/SelectOptions';
import { getInsuredRelationshipWithOwnerOptions } from '../../Helpers/Lists/InsuredRelationshipWithOwnerOptions';

const useStyles = makeStyles((theme) => ({
  slider: {
    color: `${theme.palette.primary.main} !important`,
  },
}));

export default function CaseDetails(props) {
  const {referenceID: paramReferenceID} = useParams();
  const [loading, setLoading] = useState(false);
  const [caseDetail, setCaseDetail] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [userCanCopyTicket, setUserCanCopyTicket] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    getCaseDetails();
    const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    setUserCanCopyTicket(advisorObj && advisorObj.features && advisorObj.features.enableCopyTicket);
  }, []);

  const getCaseDetails = () => {
    let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;

    httpRequest.get(`${baseAddress}/api/MorganStanley/GetCaseDetails?referenceID=${paramReferenceID.toString()}`)
      .then((data) => {
        if (data.success && data.content){
          setCaseDetail(data.content);
          setLoading(false);
        }
      });
  };

  const callGetCaseDetails = (tabNumber = 1) => {
    window.scrollTo(0,0);
    setLoading(true);
    getCaseDetails();
    setActiveTab(tabNumber);
  }

  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const role = advisorObj && advisorObj.role;

  const permission = getPermission(role, 'case-view');

  const {
    faceAmount,
    caseID,
    firstName,
    lastName,
    carrier,
    statusDescription,
    externalStatus,
    advisorWhatsNext,
    lastStatusDate,
    createdDate,
    images,
    caseSummaryHistories,
    caseManagerName,
    caseManagerProfileImageURL,
    repName,
    repProfileImageURL,
    statusCategory,
    advisorCaseTypeID,
    requestDetails,
    piIsOwner,
    ownerFirstName,
    ownerLastName,
    isAssignedMe,
    agentName,
    referenceID,
    isIllustration,
    morganStanleyQuoteIllustrationRequestID,
    oneClickRequestID,
    oneClickRequestDetailsIDList
  } = caseDetail ? caseDetail : {};

  const breadcrumbDefault = [
    {name: 'HOME', href: '/'},
    {name: 'ACTIVITY', href: '/ActivityCenter'},
  ];

  return (
    <React.Fragment>
      {loading || !caseDetail ? (
        <Row className="d-flex justify-content-center">
          <CircularProgress className="mt-5 mb-5"/>
        </Row>
      ) : (
        <React.Fragment>
          <Row>
            <Col id="breadcrumb-header" sm={12} className="mb-4">
              <Breadcrumb showBlackBreadcumb={true} breadcrumbLinks={breadcrumbDefault} currentPage={`#${caseDetail.referenceID}`}/>
            </Col>
            <Col sm={12}>
              <CaseDetailHeader productDisplayName={caseDetail.plan} coverageAmount={faceAmount}
                                proposedInsured={firstName + ' ' + lastName} carrier={carrier}
                                typeId={advisorCaseTypeID}
                                quoteTypeID={advisorCaseTypeID === AdvisorCaseType.ILLUSTRATIONREQUESTCASE ? caseDetail.requestDetails[0].quoteTypeID : null}
                                enableCopyTicket={userCanCopyTicket}
                                caseDetail={caseDetail}
              />
            </Col>
          </Row>
          <Row>
            <Col className="pr-1" sm={4}>
              <PeopleCards
                caseId={caseID}
                caseManagerName={caseManagerName}
                caseManagerProfileImageURL={caseManagerProfileImageURL}
                repName={repName}
                caseIndivdualName={firstName + ' ' + lastName}
                repProfileImageURL={repProfileImageURL}
                permission={permission}
                hasOwner={piIsOwner}
                ownerFirstName={ownerFirstName}
                ownerLastName={ownerLastName}
                isAssignedMe={isAssignedMe}
                caseDetail={caseDetail}
                agentName={agentName}
              />
            </Col>
            <Col sm={8}>
              <CaseDetailOverview
                status={statusDescription}
                nextStep={advisorWhatsNext}
                statusDetail={externalStatus}
                updateDate={lastStatusDate || createdDate}
                statuses={statuses}
                role={role}
                caseDetail={caseDetail}
                caseId={caseID}
              />
              <CaseDetailTool
                status={statusDescription}
                statuses={statuses}
                nextStep={advisorWhatsNext}
                carrier={carrier}
                statusDetail={externalStatus}
                caseImages={images}
                caseSummaryHistories={caseSummaryHistories}
                selectedCaseDetails={caseDetail}
                statusCategory={statusCategory}
                caseId={caseID}
                typeId={advisorCaseTypeID}
                requestDetails={requestDetails}
                caseDetail={caseDetail}
                permission={permission}
                callGetCaseDetails={(tabNumber)=>callGetCaseDetails(tabNumber)}
                activeTab={activeTab}
                referenceID={referenceID}
                isIllustration={isIllustration}
                morganStanleyQuoteIllustrationRequestID={morganStanleyQuoteIllustrationRequestID}
                oneClickRequestID={oneClickRequestID}
                oneClickRequestDetailsIDList={oneClickRequestDetailsIDList}
              />
            </Col>
          </Row>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function PeopleCards(props) {
  const {
    caseId,
    caseIndivdualName,
    caseManagerName,
    caseManagerProfileImageURL,
    repName,
    repProfileImageURL,
    permission,
    hasOwner,
    ownerFirstName,
    ownerLastName,
    isAssignedMe,
    caseDetail,
    agentName
  } = props;

  const people = [];

  if (!isBlank(agentName)) {
    people.push({
      name: agentName,
      role: 'FA',
      displayName: 'Financial Advisor',
      isAssignedMe: isAssignedMe
    });
  }

  if (hasOwner !== null && !hasOwner) {
    people.push({
      name: `${ownerFirstName} ${ownerLastName}`,
      role: 'Proposed Owner',
      organization: '',
      permission: permission,
    });
  }

  if (!isBlank(caseIndivdualName)) {
    people.push({
      name: caseIndivdualName,
      role: `${ hasOwner ? 'Proposed Insured & Proposed Owner' : 'Proposed Insured'}`,
      organization: '',
      permission: permission,
    });
  }

  if (!isBlank(repName)) {
    people.push({
      name: repName,
      role: 'Insurance Sales Consultant',
      organization: 'Covr',
      imageURL: repProfileImageURL,
      permission: permission,
    });
  }

  if (!isBlank(caseManagerName) && caseDetail.advisorCaseTypeID !== 3) {
    people.push({
      name: caseManagerName,
      role: 'Case Manager',
      organization: 'Covr',
      imageURL: caseManagerProfileImageURL,
    });
  }

  const peopleMap = people.map((v, i) => (
    <PersonCard
      key={i}
      name={v.name}
      role={v.role}
      displayName={v.displayName}
      imageURL={v.imageURL}
      organization={v.organization}
      caseId={caseId}
      permission={permission}
      isAssignedMe={v.isAssignedMe}
      agentName={v.agentName}
      caseDetail={caseDetail}
    />
  ));

  return peopleMap;
}

PeopleCards.propTypes = {
  caseId: PropTypes.number.isRequired,
  caseIndivdualName: PropTypes.string.isRequired,
  caseManagerName: PropTypes.string,
  caseManagerProfileImageURL: PropTypes.string,
  repName: PropTypes.string,
  repProfileImageURL: PropTypes.string,
  isAssignedMe: PropTypes.bool
};

function CaseDetailOverview(props) {
  const {
    status,
    nextStep,
    statusDetail,
    updateDate,
    statuses,
    caseDetail,
  } = props;

  const classes = useStyles();
  let statusObj = configureStatusObject(statuses, status);

  let activeStatusName = statusObj.find((item) => item.isActive === true);

  return (
    <div className="detail-card p-3">
      <Row>
        <Col sm={12} className="detail-card-header mb-0">
          <h5 id="case-status-description" className={`status mb-0 d-inline-block}`}>
            {(caseDetail.statusDescription || caseDetail.externalStatus) ? caseDetail.statusDescription + (caseDetail.statusDescription && caseDetail.externalStatus ? ` - ` : '') + caseDetail.externalStatus  : caseDetail.status}
          </h5>
          {caseDetail.advisorCaseTypeID === AdvisorCaseType.ILLUSTRATIONREQUESTCASE && <SvgIcon viewBox="0 0 30 30" className="ml-3" component={WarningGroup} />}
        </Col>
      </Row>
      <span id="steps-label" className="steps-label">Step {(getStatusProgress(activeStatusName && activeStatusName.name) / 2 / 10) || 1} of 5 </span>
      <div id="table-progress-bar" className="tableProgressBar">
        <Slider
          value={(getStatusProgress(activeStatusName && activeStatusName.name) / 2 / 10) || 1}
          valueLabelDisplay="off"
          marks
          min={0}
          max={5}
          className={`slider-progress ${classes.slider}`}
          disabled
        />
      </div>
      <Row className="mt-2">
        <Col sm={12}>
          <p id="case-external-status" className="steps-label">{caseDetail.externalStatus}</p>
        </Col>
      </Row>
      <Row>
        <Col sm={6} className='pr-0'>
          <p id="next-step-label" className={`${caseDetail.advisorCaseTypeID === AdvisorCaseType.ILLUSTRATIONREQUESTCASE ? 'detail-label mb-0' : ' detail-label-bold'}`}>
            {caseDetail.advisorCaseTypeID === AdvisorCaseType.ILLUSTRATIONREQUESTCASE ? 'Advisor Next Step:' : <b>Your Next Step:</b>}
          </p>
          <p id="next-step" className="step-detail-label">{nextStep}</p>
        </Col>
        {caseDetail.advisorCaseTypeID === AdvisorCaseType.ILLUSTRATIONREQUESTCASE ?
        <Col sm={6}>
          <p id="last-update-date" className="detail-label-bold">
            <span className='pr-5'><b>Last Update</b></span> {updateDate ? ConvertUTCToLocalDate(updateDate) : 'Unknown'}
          </p>
        </Col> :
        <React.Fragment>
        <Col sm={2} className='pl-0'>
          <p id="date-received" className="detail-label-bold">
            <b>Date Received</b> <br /> {caseDetail.createdDate ? ConvertUTCToLocalDate(caseDetail.createdDate) : 'Unknown'}
          </p>
        </Col>
        <Col sm={2} className='pl-0'>
          <p id="case-reference-id" className="detail-label-bold">
            <b>Reference ID</b> <br /> {`#${caseDetail.referenceID}` || 'Unknown'}
          </p>
        </Col>
        <Col sm={2} className='pl-0'>
          <p id="policy-number" className="detail-label-bold">
            <b>Policy Number</b> <br /> {caseDetail.policyNumber !== null ? `#${caseDetail.policyNumber}` : 'Unknown'}
          </p>
        </Col>
      </React.Fragment>
    }
      </Row>
    </div>
  );
}

CaseDetailOverview.propTypes = {
  status: PropTypes.string.isRequired,
  nextStep: PropTypes.string.isRequired,
  statusDetail: PropTypes.string.isRequired,
  updateDate: PropTypes.string.isRequired,
  carrier: PropTypes.string,
  product: PropTypes.string,
  statuses: PropTypes.array,
  role: PropTypes.string,
};

function CaseDetailHeader(props) {

  const { proposedInsured, coverageAmount, carrier, typeId, productDisplayName, quoteTypeID, enableCopyTicket, caseDetail } = props;

  const accountType = caseDetail.clientAccountInfo !== '' ? (JSON.parse(caseDetail.clientAccountInfo)).accountType : '';
  const history = useHistory();

  const handleCopyCase = () => {
    const advisorObject = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    if (!caseDetail || !advisorObject) {
      console.error("Cannot copy a case if case or advisor details could not be fetched!");
      return;
    }

    const advisorInfo = {
      firstName: advisorObject && advisorObject.fullName.split(' ')[0],
      lastName: advisorObject && advisorObject.fullName.split(' ')[1]
    };

    const selectedProduct = {
      submitCaseProductKey : caseDetail.referenceID && caseDetail.referenceID.split('-')[0]
    };

    const isTerm = selectedProduct.submitCaseProductKey === "TERM";
    const isLTC = selectedProduct.submitCaseProductKey === "LTC";
    let ltcPremiumOption = [];
    for (let i = 50000; i <= 500000; i += 50000) {
      ltcPremiumOption.push(`${i}`);
    }

    const copiedRetrieveAccount = {
      officeFa: (caseDetail.faOfficeNumberInput && caseDetail.faidInput) ? `${caseDetail.faOfficeNumberInput}-${caseDetail.faidInput}` : '',
      officeAccount: (caseDetail.clientBranchNumber && caseDetail.clientAccountNumber) ? `${caseDetail.clientBranchNumber}-${caseDetail.clientAccountNumber}` : '',
      isProposedInsured: caseDetail.isSurvivorshipPolicyType ? '' : (caseDetail.piIsOwner === true ? "true" : (caseDetail.piIsOwner === false ? "false" : "")),
      officeNum: caseDetail.faOfficeNumberInput,
      accountNum: caseDetail.clientAccountNumber,
      advisor: (caseDetail.agentID && caseDetail.agentID.toString()) || "" ,
      policyOwnership: caseDetail.policyOwnerShip ? (caseDetail.policyOwnerShip === "INDV" ? policyOwnerships.INDIVIDUAL : (caseDetail.policyOwnerShip.toLowerCase() === policyOwnerships.JOINT ? policyOwnerships.JOINT : '')) : '',
      insurancePolicyType: caseDetail.isSurvivorshipPolicyType ? insurancePolicyTypes.SURVIVORSHIP : insurancePolicyTypes.INDIVIDUAL,
      insured: caseDetail.isSurvivorshipPolicyType && caseDetail.insuredType === 'Other' ? 'Other' : '',
      secondInsured: caseDetail.isSurvivorshipPolicyType && caseDetail.secondaryInsuredType === 'Other' ? 'Other' : '',
      copiedOwnerInsuredData: {
        ownerFirstName: caseDetail.ownerFirstName,
        ownerLastName: caseDetail.ownerLastName,
        ownerBirthDate: caseDetail.ownerBirthDate ? format(new Date(caseDetail.ownerBirthDate), 'MM/dd/yyyy') : null,
        jointOwnerFirstName: caseDetail.jointOwnerFirstName,
        jointOwnerLastName: caseDetail.jointOwnerLastName,
        jointOwnerBirthDate: caseDetail.jointOwnerBirthDate ? format(new Date(caseDetail.jointOwnerBirthDate), 'MM/dd/yyyy') : null,
        piIsOwner: caseDetail.insuredType !== 'Other',
        piFirstName: caseDetail.firstName,
        piLastName: caseDetail.lastName,
        piBirthdate: caseDetail.birthDate ? format(new Date(caseDetail.birthDate), 'MM/dd/yyyy') : null,
        secondaryInsuredSameAsOwner: caseDetail.secondaryInsuredType !== 'Other',
        pi2FirstName: caseDetail.secondaryInsuredFirstName,
        pi2LastName: caseDetail.secondaryInsuredLastName,
        pi2Birthdate: caseDetail.secondaryInsuredBirthDate ? format(new Date(caseDetail.secondaryInsuredBirthDate), 'MM/dd/yyyy') : null,
      }
    };

    const copiedSelectProduct = {
      carrier: caseDetail.morganStanleyCarrierCode,
      carrierName: caseDetail.carrier,
      productCode: caseDetail.morganStanleyProductCode,
      product: caseDetail.plan,
      coverage: caseDetail.faceAmount,
      benefitDuration: (!isTerm && caseDetail.termLength ? caseDetail.termLength : ''),
      premium: (isTerm || caseDetail.premium === 0 ? '' : (isLTC && caseDetail.premiumAmount && ltcPremiumOption.includes(caseDetail.premiumAmount.toString())) ? caseDetail.premiumAmount.toString() : 'specificPremium'),
      specificPremium: (isTerm || caseDetail.premium === 0 ? '' : caseDetail.premiumAmount.toString()),
      premiumMode: (isTerm || caseDetail.premiumMode === "N/A" ? '' : caseDetail.premiumMode),
      firstYearPremium: caseDetail.firstYearPremium,
      recurringAnnualPremium: caseDetail.annualPremium,
      eliminationPeriod: caseDetail.eliminationPeriod,
      benefitPeriod: caseDetail.benefitPeriod,
      benefitPeriodOther: caseDetail.benefitPeriodOther
    };

    const copiedApplicationInformation = {
      applicationState: caseDetail.applicationState,
      solicitationState: caseDetail.solicitationState,
      deliveryState: caseDetail.deliveryState,
      replacement: (caseDetail.isReplacement ? "yes" : "no"),
      sourceOfFunds: (!caseDetail.isReplacement ? "DirectBusiness" : getNormalizedOptionValue(caseDetail.sourceOfFunds, SourceOfFunds())),
      exchangeLumpSum: (caseDetail.isReplacement ? caseDetail.lumpSumAmount : 0),
      applicationDate: format(new Date(caseDetail.applicationDate), 'MM/dd/yyyy'),
      solicitationDate: format(new Date(caseDetail.solicitationDate), 'MM/dd/yyyy'),
      purpose: caseDetail.purposeForPolicy,
      otherPurpose: caseDetail.otherPurpose ? caseDetail.otherPurpose : '',
    };

    let copiedInsuredBasicInfo = {
      proposedInsuredFirstName: caseDetail.firstName,
      proposedInsuredMiddleInitial: caseDetail.middleName,
      proposedInsuredLastName: caseDetail.lastName,
      gender: caseDetail.gender,
      birthdate: format(new Date(caseDetail.birthDate), 'MM/dd/yyyy'),
      state: caseDetail.state,
      maritalStatus: (caseDetail.maritalStatus && caseDetail.maritalStatus.toLowerCase()) == "married" ? "M" : "S",
      tobacco: caseDetail.tobaccoUse ? 'true' : 'false',
      proposedInsuredEmail: caseDetail.email,
      proposedInsuredPhone: GetFormattedNumber(caseDetail.primaryPhone),
      insuredRelationshipWithOwner: getNormalizedOptionValue(caseDetail.insuredRelationshipWithOwner, getInsuredRelationshipWithOwnerOptions(accountType)),
      isOther: caseDetail.isSurvivorshipPolicyType ? caseDetail.insuredType === 'Other' : !caseDetail.piIsOwner,
    };

    if (caseDetail.isSurvivorshipPolicyType) {
      copiedInsuredBasicInfo = {
        ...copiedInsuredBasicInfo,
        secondaryInsuredFirstName: caseDetail.secondaryInsuredFirstName,
        secondaryInsuredLastName: caseDetail.secondaryInsuredLastName,
        secondaryInsuredMiddleInitial: caseDetail.secondaryInsuredMiddleInitial,
        secondaryInsuredGender: caseDetail.secondaryInsuredGender,
        secondaryInsuredBirthdate: format(new Date(caseDetail.secondaryInsuredBirthDate), 'MM/dd/yyyy'),
        secondaryInsuredState: caseDetail.secondaryInsuredAddressState,
        secondaryInsuredMaritalStatus: (caseDetail.secondaryInsuredMaritalStatus && caseDetail.secondaryInsuredMaritalStatus.toLowerCase()) === "married" ? "M" : "S",
        secondaryInsuredTobacco: caseDetail.secondaryInsuredTobacco,
        secondaryInsuredEmail: caseDetail.secondaryInsuredEmail,
        secondaryInsuredPhone: GetFormattedNumber(caseDetail.secondaryInsuredPhone),
        secondaryInsuredRelationshipWithOwner: getNormalizedOptionValue(caseDetail.secondaryInsuredRelationshipWithOwner, getInsuredRelationshipWithOwnerOptions(accountType)),
        isSecondaryInsuredOther: caseDetail.secondaryInsuredType === 'Other',
      }
    }

    let copiedReplaceFile;

    if (caseDetail.images && caseDetail.images.length > 0) {
      const firstImg = caseDetail.images[0];

      copiedReplaceFile = {
        ...copiedReplaceFile,
        imageFileName: firstImg.imageName,
        imageID: firstImg.morganStanleyQuoteImageID,
        file: {
          fileList: [
            {
              dateTime: ConvertUTCToLocalDateTime(format(new Date(firstImg.createdDate), 'MM/dd/yyyy hh:mm')),
              extension: firstImg.imageExtension,
              name: firstImg.imageName,
            }
          ]
        }
      };
    }

    const copiedTicketFormState = {
      currentStep: 1,
      isCopyCaseData: true,
      pages: {
        retrieveAccount: { ...Steps.RetrieveAccount.DefaultFormState(), ...copiedRetrieveAccount },
        insuredBasicInfo: { ...Steps.InsuredBasicInfo.DefaultFormState(), ...copiedInsuredBasicInfo },
        esign: Steps.ESign.DefaultFormState(false, advisorInfo),
        replaceFile: { ...Steps.ReplaceFile.DefaultFormState(), ...copiedReplaceFile },
        applicationInformation: { ...Steps.ApplicationInformation.DefaultFormState(), ...copiedApplicationInformation },
        yourInformation: Steps.YourInformation.DefaultFormState(),
        selectProduct: { ...Steps.SelectProduct.DefaultFormState(false, selectedProduct), ...copiedSelectProduct }
      }
    };

    setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, history.location.pathname);

    if (isTerm) {
      const termLength = caseDetail.termLength && caseDetail.termLength.split(' ')[0];
      const healthClass = (caseDetail.healthClassCode && caseDetail.healthClassCode.toUpperCase()) || 'R';
      copiedTicketFormState.pages.quoter = { ...TermSteps.Quoter.DefaultFormState(), ...{ coverageAmount: caseDetail.faceAmount, term: Number.parseInt(termLength, 10), healthClass } };
      copiedTicketFormState.pages.attestation = TermSteps.Attestation.DefaultFormState();
      setSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, copiedTicketFormState);
      history.push('/Products/Term');
    } else {
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedProduct);
      setSessionStorageItem(SESSION_STORAGE_CREATE_CASE, copiedTicketFormState);
      history.push('/Activity/NewCase/Client');
    }
  }

  return (
    <div className="details-head">
      <h2 id="product-header">{proposedInsured} {productDisplayName ? `- ${productDisplayName}` : ''}</h2>
      {typeId === AdvisorCaseType.ILLUSTRATIONREQUESTCASE ?
        <h4 id="product-type">
          {`${getQuoteTypeFromID(quoteTypeID)} Illustration Request`}
        </h4> :
        <h4 id="product-type">
          {(coverageAmount ? <NumberFormat displayType={'text'} prefix={'$'} value={coverageAmount}
            thousandSeparator={true}/> : '') || 'Coverage Amount Unknown'} -{' '}
          {carrier || 'Carrier Unknown'}
        </h4>}
      <Row>
        <Col md="8">
          <h5 id="associated-text" className='mb-1'>Associated with this case</h5>
        </Col>
        <Col md="4">
          <div className="d-flex float-right">
            {(enableCopyTicket && caseDetail && !caseDetail.isIllustration) && (
              <Button className="copy-case-button" color="primary" onClick={() => handleCopyCase() }>COPY CASE</Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

CaseDetailHeader.propTypes = {
  proposedInsured: PropTypes.string.isRequired,
  coverageAmount: PropTypes.number,
  carrier: PropTypes.string,
  typeId: PropTypes.number,
  enableCopyTicket: PropTypes.bool,
  caseDetail: PropTypes.object
};




// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseDetails.js